import React from 'react';

export interface StarIconProps {
  className?: string;
  size?: number;
}

export const StarIcon: React.FC<StarIconProps> = ({ className, size = 9 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 0L5.5 3.5L9 4.5L5.5 5.5L4.5 9L3.5 5.5L0 4.5L3.5 3.5L4.5 0Z"
        fill="url(#starGradient)"
      />
      <defs>
        <linearGradient
          id="starGradient"
          x1="0"
          y1="4.5"
          x2="9"
          y2="4.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="59.32%" stopColor="#32EDDA" />
          <stop offset="108.17%" stopColor="#017064" />
        </linearGradient>
      </defs>
    </svg>
  );
};